import React from 'react';

export function useFixColorScheme(scheme: 'light' | 'dark') {
    React.useEffect(() => {
        const colorSchemeListener = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = () => document.documentElement.setAttribute('color-scheme', scheme);

        handler();

        colorSchemeListener.addEventListener('change', handler);

        return () => {
            document.documentElement.removeAttribute('color-scheme');
            colorSchemeListener.removeEventListener('change', handler);
        };
    }, [scheme]);
}
